import React from "react";
import { useSearchParams } from "react-router-dom";
import TOISignup from "./toi/TOIEmailSignup";
import Signup from "./SignUp";
import { REMITTANCE_SIGNUP } from "../config/constants";
import TOIMobileSignup from "./toi/TOIMobileSignup";

function SignupV2({ screenType }) {
  const [searchParams] = useSearchParams();
  const source = screenType ? screenType : searchParams.get("source");
  const sourceList = ["toi", REMITTANCE_SIGNUP, "toiplus"];
  return (
    <>
      {source === "toi" && <TOISignup />}
      {source === "toiplus" && <TOIMobileSignup />}
      {source === REMITTANCE_SIGNUP && <Signup screenType={screenType} />}
      {!sourceList.includes(source) && <Signup />}
    </>
  );
}

export default SignupV2;
